import React from 'react';
import {permissionObj} from '../../../Helpers/permission';
import routes from '../../../Routes/routes';
import HeadTittle from '../../../components/HeadTittle';
import {Box} from '@mui/material';
import DivContainerBody from '../../../components/DivContainerBody';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../components/StepperTabs/StepTab';
import KitchenMainApp from './Functionality/KitchenMainApp';
import { TABS_KITCHEN } from './Model/Models';
import Order from './SubComponents/Order';
import KitchenHistory from './SubComponents/KitchenHistory';
import KitchenStatus from './SubComponents/KitchenStatus';
import {IconBackLoginOptions} from '../../../components/buttons/IconButtons';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const KitchenMain = () => {

    const props = KitchenMainApp();
    const {
        DEV,
        permission,
        navigate,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        isOnline,
        item,
        handleChange,
        search,
        setSearch,
        setIsOnline,
        modified,
        setModified,
        history,
        onChange,
        setSimpleSearch
    } = props;

    if( !DEV &&
        !permission?.includes(permissionObj?.WEB_KITCHEN_TICKETS_READ) &&
        !permission?.includes(permissionObj?.WEB_KITCHEN_TICKETS_HISTORY_READ) )
            navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'kitchen_tickets'} IconBack={IconBackLoginOptions} link={routes.login}>
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>
                    <KitchenStatus
                        isOnline={isOnline}
                        setModified={setModified}
                        activeStep={activeStep}
                        item={item}
                    />
                </Box>
            </HeadTittle>

            <DivContainerBody>
                <StepperTabs
                    onlyTab={true}
                    disabled={false}
                    steps={steps}
                    activeStep={activeStep}
                    isStepOptional={() => {}}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                >
                    <StepTab index={TABS_KITCHEN.ORDERS.INDEX} activeStep={activeStep}>
                        { activeStep === TABS_KITCHEN.ORDERS.INDEX &&
                            <Order
                                activeStep={activeStep}
                                item={item}
                                handleChange={handleChange}
                                search={search}
                                setSearch={setSearch}
                                isOnline={isOnline}
                                setIsOnline={setIsOnline}
                                modified={modified}
                                setModified={setModified}
                            />
                        }
                    </StepTab>
                    <StepTab index={TABS_KITCHEN.HISTORY.INDEX} activeStep={activeStep}>
                        {activeStep === TABS_KITCHEN.HISTORY.INDEX &&
                            <KitchenHistory
                                activeStep={activeStep}
                                history={history}
                                onChange={onChange}
                                search={search}
                                setSearch={setSearch}
                                modified={modified}
                                setModified={setModified}
                                setSimpleSearch={setSimpleSearch}
                            />
                        }
                    </StepTab>
                </StepperTabs>
            </DivContainerBody>
        </>
    );
};

export default KitchenMain;
